/* Corporate Grind - Page Vibe Detection v2 */
(function() {
  function init() {
    const bodyEl = document.body;
    const path = window.location.pathname;
    
    // Set template type
    if (path === '/' || path === '') {
      bodyEl.setAttribute('data-template', 'index');
    } else if (path.includes('/collections/')) {
      bodyEl.setAttribute('data-template', 'collection');
      const match = path.match(/\/collections\/([^\/\?]+)/);
      if (match) {
        bodyEl.setAttribute('data-collection', match[1]);
        console.log('[CG] Collection vibe:', match[1]);
      }
    } else if (path.includes('/products/')) {
      bodyEl.setAttribute('data-template', 'product');
    }
  }
  
  // Run immediately and on DOM ready
  init();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
